import { BaseModel } from '@tcc-mono/shared/data-access';
import { PurchaseOrder } from './purchase-order.model';

export class PurchaseInvoice extends BaseModel {
  id: number;
  address: string;
  address_zip: string;
  address_city: string;
  address_country: string;
  delivery_date: string;
  invoice_date: string;
  purchase_date: string;
  relation_id: number;
  relation_name?: string;
  lines: PurchaseInvoiceLine[];
  created_at?: string;
  exact_exported_at?: string;
  invoice_number?: string;
  sum?: string;
  net_sum?: string;
  updated_at?: string;
  relation_exact_code?: string;
  relation_email?: string;
  mail_status?: string;
}

export class PurchaseInvoiceLine {
  id?: number;
  purchase_invoice_id: number;
  date: string;
  description?: string;
  pcs: number;
  unit_price: number;
  sum: number;
  purchase_order: PurchaseOrder;
  purchase_order_id: number;
  weight: number;
}
